/* WCAG - Fix focusable links in aria-hidden swiper slides */
function fixHiddenSlideLinks() {
  document.querySelectorAll('[aria-hidden="true"] a[data-main-media-link]').forEach(function(link) {
    link.setAttribute('tabindex', '-1');
  });
}

// Run on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  fixHiddenSlideLinks();
  setInterval(fixHiddenSlideLinks, 200);
});

// Also run immediately in case DOM is already ready
fixHiddenSlideLinks();

// Run on any page interaction to catch late swiper initialization
window.addEventListener('load', fixHiddenSlideLinks);
document.addEventListener('scroll', fixHiddenSlideLinks, { once: true });